import $ from 'jquery';

const ready = function () {
  $('[rel="popover"], [data-toggle="popover"]').popover({
    placement: 'top',
    html: true
  });

  $('[data-toggle="tooltip"]').tooltip();

  $(document)
    .on('page:fetch', function () {
      $('#spinner').show();
    })
    .on('page:change', function () {
      $('#spinner').hide();
    })
    .on('click', '.submit-current-form', function (e) {
      e.preventDefault();
      const form = $('form:visible:last')[0];
      if (form) {
        form.dispatchEvent(new Event('submit', { bubbles: true }));
      }
    });

  $(document).on('click', '.js-copy', function () {
    $(this).closest('.input-group').find('input').select();
    try {
      $(document)[0].execCommand('copy');
    } catch {
      return;
    }
    return false;
  });

  if ($('.company-edit-page').length) {
    $('a[href="' + location.hash + '"]').click();
  }
};

document.addEventListener('turbolinks:load', ready);
document.addEventListener('ajax:success', ready);
